export default "__VITE_ASSET__UNNnwL5d__"